module.exports = __webpack_public_path__ + "static/img/foreign_sales.b9ecf839.png";